import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectClientConfig,
  selectClientFormErrors,
  selectProfessionalClientSubscriptionData,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import {
  addClientError,
  removeClientError,
  updateClientData,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import { subscriptionFormActionsV2 } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'
import useFormStatus from '@/containers/SubscriptionFormPageNew/SubscriptionForm/useFormStatus'
import getError from '@/containers/SubscriptionFormPage/getError'
import { mandatoryTag } from '@/containers/SubscriptionFormPageNew/isMandatory'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { modulesConfig } from '@/containers/SubscriptionFormPageNew/config'

const FISCAL_CODE_LENGTH_BY_COUNTRY = {
  it: 16,
}

const useFiscalCode = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { taxId } = useSelector(selectProfessionalClientSubscriptionData)
  const errors = useSelector(selectClientFormErrors)
  const { fiscalCodeIsLoading, fiscalCodeIsValid } = useSelector(selectClientConfig)
  const { isEditable } = useFormStatus()
  const { country } = useSelector(selectAuthData)
  // @ts-ignore
  const customerConfig = modulesConfig[country]?.customer ?? {}

  const fiscalCodeLength = FISCAL_CODE_LENGTH_BY_COUNTRY[country as keyof typeof FISCAL_CODE_LENGTH_BY_COUNTRY]
  const label = mandatoryTag + t('subscriptionForm:customer_module.taxIdCode.label')
  const error = getError('taxIdCode', errors)

  const getStatus = () => {
    if (fiscalCodeIsLoading) return 'loading'

    if (fiscalCodeIsValid === true) return 'valid'

    if (fiscalCodeIsValid === false) return 'error'

    return undefined
  }

  const onBlur = (value: string | null) => {
    // @ts-ignore
    dispatch(removeClientError('taxIdCode'))
    // @ts-ignore
    dispatch(updateClientData({ data: { fiscalCodeIsValid: null }, name: 'config' }))
    // @ts-ignore
    dispatch(updateClientData({ data: { taxId: value }, name: 'professional' }))
    const trimmed = (value ?? '').trim()
    if (fiscalCodeLength && trimmed.length === fiscalCodeLength) {
      dispatch({ type: subscriptionFormActionsV2.CUSTOMER_MODULE_VERIFY_ITALY_FISCAL_CODE_V2, fiscalCode: trimmed })
      return
    }
    // @ts-ignore
    dispatch(addClientError({ key: 'taxIdCode', message: t('subscriptionForm:customer_module.taxIdCode.invalid') }))
  }

  return {
    taxId,
    label,
    error,
    isEditable,
    status: getStatus(),
    onBlur,
    hidden: !customerConfig.taxId,
  }
}

export default useFiscalCode
